<template lang="pug">
    dynamic-filter-picker(
        title="Custom Filter"
    )
        div(slot="body")
            div(v-if="multiple_product")
                product-dynamic-filter
            div(v-else-if="voided_type")
                voided-type-dynamic-filter
            div(v-else-if="product_category")
                product-category-dynamic-filter
            div(v-else)
                till-dynamic-filter(:till_columns="till_columns")
</template>

<script>
import dynamicFilterPicker from '@js/components/filter/dynamic-filter-picker';
import productDynamicFilter from './product/product-dynamic-filter';
import tillDynamicFilter from '../till-filter/till-dynamic-filter';
import voidedTypeDynamicFilter from '../voided-type-filter/voided-type-dynamic-filter';
import productCategoryDynamicFilter from './profit/product-category-dynamic-filter';

export default {
    components: {
        productDynamicFilter,
        dynamicFilterPicker,
        tillDynamicFilter,
        voidedTypeDynamicFilter,
        productCategoryDynamicFilter,
    },

    props: {
        multiple_product: {
            type: Boolean | Number,
            default: false,
        },

        voided_type: {
            type: Boolean | Number,
            default: false,
        },

        till_columns: {
            type: Object | Array,
            default: () => null,
        },

        product_category: {
            type: Boolean | Number,
            default: false,
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/filter/custom-filter.vue